import { createEvent, createStore, sample } from 'effector'
import { backRouteFx } from 'src/infastruct/effector-utils/attach-router'

export const $historyPaths = createStore<string[]>([], {
    serialize: 'ignore'
})
export const addHistoryPath = createEvent<string>()
export const popHistoryPath = createEvent()

sample({
    clock: addHistoryPath,
    source: $historyPaths,
    fn: (paths, newPath) => {
        if (paths && paths.length > 0) {
            paths.push(newPath)
            return [...paths]
        }
        return [newPath]
    },
    target: $historyPaths
})

sample({
    clock: popHistoryPath,
    source: $historyPaths,
    filter: (paths) => paths && paths.length > 0,
    fn: (paths) => {
        paths.pop()
        return [...paths]
    },
    target: [$historyPaths, backRouteFx]
})
